import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo2 from ".././assets/img/logo2.png";
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Image,
    Modal,
    Button,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaFacebook, FaInstagram, FaTiktok, FaWhatsapp } from "react-icons/fa6";
import { FiHelpCircle, FiPhone, FiMail, FiX, FiCopy, FiPlay } from "react-icons/fi";
import ar from "assets/img/flags/ar.png";
import fr from "assets/img/flags/fr.png";
import en from "assets/img/flags/en.png";
import { useIsMobile } from "hooks/useIsMobile";

const LANGUAGES = [
    {
        code: "en",
        lang: "EN",
        flag: en,
    },
    {
        code: "fr",
        lang: "FR",
        flag: fr,
    },
    {
        code: "ar",
        lang: "AR",
        flag: ar,
    },
];

const Header = () => {
    const { i18n, t } = useTranslation();
    const { isMobile } = useIsMobile();
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [copyNotification, setCopyNotification] = useState('');

    const changeLanguage = (code) => {
        i18n.changeLanguage(code);
        localStorage.setItem("lang", code);
        if (code === "ar") {
            document.body.dir = "ltr";
        } else {
            document.body.dir = "ltr";
        }
    };

    const copyToClipboard = (text, label) => {
        navigator.clipboard.writeText(text);
        const translationKey = label === 'Numéro' || label === 'Number' ? 'numberCopied' : 'emailCopied';
        setCopyNotification(t(translationKey));
        setTimeout(() => setCopyNotification(''), 2000);
    };

    const handleCloseHelpModal = () => setShowHelpModal(false);
    const handleShowHelpModal = () => setShowHelpModal(true);

    return (
        <>
            <header className="main_header_arae">
                <div className="bg-main-color md:bg-transparent py-1.5 sticky top-0 z-50 md:static">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="flex justify-end">
                                <ul className=" text-[12px] md:text-[13px] flex flex-row gap-3 items-center">
                                    <li className=" text-white items-center flex flex-row gap-2">
                                        <Link
                                            target="_blank"
                                            to="https://www.tiktok.com/@jevoyageici?_t=ZS-8zdlus39zI9&_r=1"
                                        >
                                            <FaTiktok
                                                size={25}
                                                className="text-white"
                                            />
                                        </Link>
                                        <Link
                                            target="_blank"
                                            to="https://www.facebook.com/share/1FG6qmTjfr/?mibextid=wwXIfr"
                                        >
                                            <FaFacebook
                                                size={25}
                                                className="text-white"
                                            />
                                        </Link>
                                        <Link
                                            target="_blank"
                                            to="https://www.instagram.com/aquaterra_travel?igsh=bzdvMnNsZXNkYXVl&utm_source=qr"
                                        >
                                            <FaInstagram
                                                size={25}
                                                className="text-white"
                                            />
                                        </Link>
                                        <Link
                                            target="_blank"
                                            to="https://wa.me/213770722259"
                                        >
                                            <FaWhatsapp
                                                size={25}
                                                className="text-white"
                                            />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#!" className=" text-white" style={{ fontSize: '16px' }}>
                                            <span>
                                                +213770268725
                                            </span>
                                        </Link>
                                    </li>
                                    <li>
                                        <a
                                            href="mailto:jevoyageici@gmail.com"
                                            className="text-white"
                                            style={{ fontSize: '16px' }}
                                        >
                                            jevoyageici@gmail.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="navbar-area  z-40 bg-transparent">
                    <div className="container">
                        <nav className="flex items-center justify-between gap-4">
                            <Link className=" flex items-center" to="/">
                                {isMobile ? (
                                    <img
                                        className=" w-[200px]"
                                        src={logo2}
                                        alt="logo"
                                    />
                                ) : (
                                    <img
                                        className="w-[300px] h-auto"
                                        src={logo2}
                                        alt="logo"
                                    />
                                )}
                            </Link>

                            <div className="flex items-center gap-3">
                                {/* Guide Button */}
                                <Link
                                    to="/tutoriels"
                                    className="guide-button-header"
                                    title={t("guideBtn") || "Guide"}
                                >
                                    <FiPlay size={18} />
                                    {!isMobile && <span className="guide-text">{t("guideBtn") || "Guide"}</span>}
                                </Link>

                                {/* Help Button */}
                                <button
                                    onClick={handleShowHelpModal}
                                    className="help-button-header"
                                    title={t("needHelp") || "Besoin d'aide"}
                                >
                                    <FiHelpCircle size={20} />
                                    {!isMobile && <span className="help-text">{t("needHelp") || "Aide"}</span>}
                                </button>

                                <Dropdown>
                                <DropdownToggle
                                    as="button"
                                    className="lang-dropdown-toggle rounded-md bg-hover-color md:bg-white"
                                    role="button"
                                >
                                    <Image
                                        className="size-[21px]"
                                        src={
                                            LANGUAGES.find(
                                                (lang) =>
                                                    lang.code === i18n.language
                                            )?.flag
                                        }
                                        alt={
                                            LANGUAGES.find(
                                                (lang) =>
                                                    lang.code === i18n.language
                                            )?.lang
                                        }
                                    />
                                </DropdownToggle>
                                <DropdownMenu
                                    align="end"
                                    className=" min-w-fit rounded-md border-none transition-custom p-2 duration-100"
                                >
                                    {(LANGUAGES ?? []).map((language, idx) => (
                                        <DropdownItem
                                            key={idx}
                                            onClick={() =>
                                                changeLanguage(language.code)
                                            }
                                            className={`flex items-center justify-between gap-3 w-[90px] border-0 rounded-md p-2 hover:bg-hover-color ${
                                                language.code ===
                                                    i18n.language &&
                                                "bg-hover-color"
                                            } `}
                                        >
                                            <img
                                                src={language.flag}
                                                alt={language.lang}
                                                className="w-5 h-5"
                                            />
                                            <div className="">
                                                {language.lang}
                                            </div>
                                        </DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
            
            {/* Help Modal */}
            <Modal 
                show={showHelpModal} 
                onHide={handleCloseHelpModal} 
                centered 
                className="help-modal-custom"
                backdrop="static"
            >
                <Modal.Header className="border-0 bg-gradient-help">
                    <div className="w-100 py-3 px-4">
                        <Modal.Title className="text-white fw-bold d-flex align-items-center gap-2">
                            <FiHelpCircle size={24} />
                            {t('needHelp') || 'Besoin d\'aide'}
                        </Modal.Title>
                        <p className="text-white small mt-2 mb-0">
                            {t('weAreHereToHelp') || 'Notre équipe est à votre disposition'}
                        </p>
                    </div>
                    <Button 
                        variant="link" 
                        onClick={handleCloseHelpModal}
                        className="text-white close-btn-custom"
                    >
                        <FiX size={24} />
                    </Button>
                </Modal.Header>
                
                <Modal.Body className="p-4">
                    {/* Phone Numbers */}
                    <div className="mb-4">
                        <h6 className="fw-bold text-gray-800 mb-3 d-flex align-items-center gap-2">
                            <FiPhone className="text-primary" />
                            {t('phoneNumbers') || 'Téléphones'}
                        </h6>
                        <div className="space-y-2">
                            {["+213770268725"].map((phone, idx) => (
                                <div key={idx} className="contact-item-custom">
                                    <span className="phone-number">{phone}</span>
                                    <button
                                        onClick={() => copyToClipboard(phone, 'Numéro')}
                                        className="copy-btn-custom"
                                        title="Copier"
                                    >
                                        <FiCopy size={16} />
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Email */}
                    <div className="mb-4">
                        <h6 className="fw-bold text-gray-800 mb-3 d-flex align-items-center gap-2">
                            <FiMail className="text-primary" />
                            {t('email') || 'Email'}
                        </h6>
                        <div className="contact-item-custom">
                            <span className="email-address">jevoyageici@gmail.com</span>
                            <button
                                onClick={() => copyToClipboard('jevoyageici@gmail.com', 'Email')}
                                className="copy-btn-custom"
                                title="Copier"
                            >
                                <FiCopy size={16} />
                            </button>
                        </div>
                    </div>

                    {/* Social Media */}
                    <div>
                        <h6 className="fw-bold text-gray-800 mb-3">
                            {t('followUs') || 'Suivez-nous'}
                        </h6>
                        <div className="d-flex gap-3">
                            <a
                                href="https://www.facebook.com/share/1FG6qmTjfr/?mibextid=wwXIfr"
                                target="_blank"
                                rel="noreferrer"
                                className="social-btn-custom facebook-custom"
                            >
                                <FaFacebook size={18} />
                            </a>
                            <a
                                href="https://www.instagram.com/aquaterra_travel?igsh=bzdvMnNsZXNkYXVl&utm_source=qr"
                                target="_blank"
                                rel="noreferrer"
                                className="social-btn-custom instagram-custom"
                            >
                                <FaInstagram size={18} />
                            </a>
                            <a
                                href="https://www.tiktok.com/@jevoyageici?_t=ZS-8zdlus39zI9&_r=1"
                                target="_blank"
                                rel="noreferrer"
                                className="social-btn-custom tiktok-custom"
                            >
                                <FaTiktok size={18} />
                            </a>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="border-0 bg-light p-3">
                    <Button 
                        variant="primary" 
                        onClick={handleCloseHelpModal}
                        className="btn-close-help fw-semibold"
                    >
                        {t('close') || 'Fermer'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Copy Notification */}
            {copyNotification && (
                <div className="copy-notification-custom">
                    <div className="notification-content">
                        <span className="notification-text">{copyNotification}</span>
                    </div>
                </div>
            )}

            <style>{`
                .guide-button-header {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    padding: 0.5rem 1rem;
                    background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
                    border: none;
                    border-radius: 2rem;
                    color: white;
                    font-weight: 600;
                    font-size: 0.875rem;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 15px rgba(22, 163, 74, 0.3);
                    text-decoration: none;
                    position: relative;
                    overflow: hidden;
                }

                .guide-button-header::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
                    transition: left 0.5s ease;
                }

                .guide-button-header:hover::before {
                    left: 100%;
                }

                .guide-button-header:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(22, 163, 74, 0.4);
                    background: linear-gradient(135deg, #15803d 0%, #166534 100%);
                    color: white;
                    text-decoration: none;
                }

                .guide-text {
                    font-weight: 600;
                }

                @media (max-width: 768px) {
                    .guide-button-header .guide-text {
                        display: none;
                    }

                    .guide-button-header {
                        padding: 0.5rem;
                        border-radius: 50%;
                        width: 45px;
                        height: 45px;
                        justify-content: center;
                    }
                }

                .help-button-header {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    padding: 0.5rem 1rem;
                    background: linear-gradient(135deg, var(--main-color) 0%, #0a4dc4 100%);
                    border: none;
                    border-radius: 2rem;
                    color: white;
                    font-weight: 600;
                    font-size: 0.875rem;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 15px rgba(19, 95, 243, 0.3);
                    position: relative;
                    overflow: hidden;
                }

                .help-button-header::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
                    transition: left 0.5s ease;
                }

                .help-button-header:hover::before {
                    left: 100%;
                }

                .help-button-header:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(19, 95, 243, 0.4);
                    background: linear-gradient(135deg, #0a4dc4 0%, #0840a0 100%);
                }

                .help-text {
                    font-weight: 600;
                }

                .help-modal-custom .modal-content {
                    border: none;
                    border-radius: 1.5rem;
                    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
                    overflow: hidden;
                }

                .bg-gradient-help {
                    background: linear-gradient(135deg, var(--main-color) 0%, #0a4dc4 100%);
                }

                .close-btn-custom {
                    position: absolute;
                    top: 1rem;
                    right: 1rem;
                    background: rgba(255,255,255,0.1) !important;
                    border: none;
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.3s ease;
                }

                .close-btn-custom:hover {
                    background: rgba(255,255,255,0.2) !important;
                    transform: rotate(90deg);
                }

                .contact-item-custom {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0.75rem 1rem;
                    background: #f8f9fa;
                    border: 2px solid #e9ecef;
                    border-radius: 1rem;
                    transition: all 0.3s ease;
                }

                .contact-item-custom:hover {
                    border-color: var(--main-color);
                    background: #f0f4ff;
                    transform: translateX(4px);
                }

                .phone-number, .email-address {
                    font-weight: 600;
                    color: #495057;
                }

                .copy-btn-custom {
                    background: none;
                    border: none;
                    color: var(--main-color);
                    padding: 0.25rem;
                    border-radius: 0.5rem;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .copy-btn-custom:hover {
                    background: var(--main-color);
                    color: white;
                    transform: scale(1.1);
                }

                .social-btn-custom {
                    width: 45px;
                    height: 45px;
                    border-radius: 1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    text-decoration: none;
                    transition: all 0.3s ease;
                    border: 2px solid transparent;
                }

                .facebook-custom {
                    background: linear-gradient(135deg, #1877f2 0%, #0a66ff 100%);
                }

                .instagram-custom {
                    background: linear-gradient(135deg, #f13c3c 0%, #833ab4 50%, #fd1d1d 100%);
                }

                .tiktok-custom {
                    background: linear-gradient(135deg, #000000 0%, #ff0050 100%);
                }

                .social-btn-custom:hover {
                    transform: translateY(-4px) scale(1.05);
                    box-shadow: 0 8px 20px rgba(0,0,0,0.2);
                }

                .btn-close-help {
                    background: linear-gradient(135deg, var(--main-color) 0%, #0a4dc4 100%);
                    border: none;
                    padding: 0.75rem 2rem;
                    border-radius: 1rem;
                    font-weight: 600;
                    transition: all 0.3s ease;
                }

                .btn-close-help:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px rgba(19, 95, 243, 0.3);
                }

                .copy-notification-custom {
                    position: fixed;
                    top: 2rem;
                    right: 2rem;
                    z-index: 9999;
                    animation: slideInRight 0.3s ease-out;
                }

                .notification-content {
                    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
                    color: white;
                    padding: 1rem 1.5rem;
                    border-radius: 1rem;
                    box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                }

                .notification-text::before {
                    content: '✓';
                    font-weight: bold;
                    margin-right: 0.5rem;
                }

                @keyframes slideInRight {
                    from {
                        transform: translateX(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }

                @media (max-width: 768px) {
                    .help-button-header .help-text {
                        display: none;
                    }
                    
                    .help-button-header {
                        padding: 0.5rem;
                        border-radius: 50%;
                        width: 45px;
                        height: 45px;
                    }
                }
            `}</style>
        </>
    );
};

export default Header;
